/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Events_MismatchInputs */

const cs_portals_events_mismatch = /** @type {(inputs: Portals_Events_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nesoulad`)
};

const en_portals_events_mismatch = /** @type {(inputs: Portals_Events_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mismatch`)
};

/**
* | output |
* | --- |
* | "Mismatch" |
*
* @param {Portals_Events_MismatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_events_mismatch = /** @type {((inputs?: Portals_Events_MismatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Events_MismatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_events_mismatch(inputs)
	return cs_portals_events_mismatch(inputs)
});